export const TEAM_ID_NAMESPACES = Object.freeze({
  BASKETBALL_V1: 'basketball-v1',
  NBA_V2: 'nba-v2',
  UNIFIED: 'unified'
});

export const isBasketballV1Namespace = (namespace) =>
  namespace === TEAM_ID_NAMESPACES.BASKETBALL_V1;
